import { render, staticRenderFns } from "./addOrEdit.vue?vue&type=template&id=5c5dd33c&scoped=true"
import script from "./addOrEdit.vue?vue&type=script&lang=js"
export * from "./addOrEdit.vue?vue&type=script&lang=js"
import style0 from "./addOrEdit.vue?vue&type=style&index=0&id=5c5dd33c&prod&lang=scss&scoped=true"
import style1 from "./addOrEdit.vue?vue&type=style&index=1&id=5c5dd33c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5dd33c",
  null
  
)

export default component.exports